import React from 'react';

import { Flex, Text } from '@rover/kibble/core';

type ServiceRowProps = {
  header: string;
  priceText: string;
  description?: string;
};

const ServiceRow = ({ header, priceText, description }: ServiceRowProps): JSX.Element => {
  return (
    <Flex width="100%" justifyContent="space-between">
      <Text>{header}</Text>
      <Flex flexDirection="column" alignItems="end" textAlign="right">
        <Text fontWeight="semibold">{priceText}</Text>
        {description && (
          <Text size="100" textColor="tertiary">
            {description}
          </Text>
        )}
      </Flex>
    </Flex>
  );
};

export default ServiceRow;
